module.exports = __webpack_public_path__ + "img/ins-advantage1.f3325450.svg";